export const indWVsIreWContestListByCategory = [
  {
    _id: '61821e0cb2569b001f9ddf50',
    contests: [
      {
        _id: '63d294d767b0c2001d35fc3b',
        createdOn: '2022-03-22T10:21:44.679Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 02',
        description: '7 teams per user/100 spots',
        minimumPlayers: 200,
        maximumPlayers: 200,
        maxTeamPerUser: 7,
        winningsAmount: 500000,
        entryFee: 3000,
        winningsPerPosition: {
          '5000': 30,
          '10000': 10,
          '25000': 1,
          '40000': 1,
          '50000': 1,
          '60000': 1,
          '75000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc47',
        createdOn: '2022-03-22T10:31:45.450Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 03',
        description: '8 teams per user/300 spots',
        minimumPlayers: 300,
        maximumPlayers: 300,
        maxTeamPerUser: 8,
        winningsAmount: 400000,
        entryFee: 1500,
        winningsPerPosition: {
          '2000': 50,
          '3000': 25,
          '5000': 15,
          '10000': 10,
          '15000': 2,
          '20000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc4b',
        createdOn: '2022-03-21T09:56:33.446Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Fight of Eight',
        description: '8 teams in one contest',
        minimumPlayers: 8,
        maximumPlayers: 8,
        maxTeamPerUser: 2,
        winningsAmount: 12000,
        entryFee: 2000,
        winningsPerPosition: {
          '1000': 1,
          '2000': 1,
          '4000': 1,
          '5000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: true,
        isDynamicWinnings: false,
        adminFees: 4000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 2,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc4f',
        createdOn: '2022-03-22T10:11:34.371Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce453',
        contestCategoryId: '61821e0cb2569b001f9ddf50',
        tenant: 'dev',
        title: 'Testing 01',
        description: '100 Spots in One contest ',
        minimumPlayers: 100,
        maximumPlayers: 100,
        maxTeamPerUser: 6,
        winningsAmount: 200000,
        entryFee: 2500,
        winningsPerPosition: {
          '2500': 4,
          '3000': 10,
          '5000': 2,
          '10000': 1,
          '20000': 1,
          '30000': 1,
          '40000': 1,
          '50000': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 50000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '6180fa03b2569b001f9dde16',
    contests: [
      {
        _id: '63d294d767b0c2001d35fc31',
        createdOn: '2021-11-26T13:15:29.511Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 30',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 5200,
        entryFee: 3000,
        winningsPerPosition: {
          '5200': 1
        },
        selfReplicating: true,
        bonusPercentage: 5,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 800,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc41',
        createdOn: '2022-03-21T08:19:22.807Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Small League ',
        description: 'Invest small win big ',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 1800,
        entryFee: 1000,
        winningsPerPosition: {
          '1800': 1
        },
        selfReplicating: false,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc33',
        createdOn: '2021-12-01T11:09:34.975Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2h',
        description: 'contest',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 220000,
        entryFee: 115000,
        winningsPerPosition: {
          '220000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 10000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc39',
        createdOn: '2021-11-03T10:40:34.493Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'Test',
        description: 'Test',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 600,
        entryFee: 400,
        winningsPerPosition: {
          '600': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc3f',
        createdOn: '2021-11-26T13:16:54.011Z',
        deletedOn: null,
        contestTypeId: '5fd31017dedfcb06b5cd21d1',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 40',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 7000,
        entryFee: 4000,
        winningsPerPosition: {
          '7000': 1
        },
        selfReplicating: true,
        bonusPercentage: 20,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 1000,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc49',
        createdOn: '2021-11-26T13:13:58.382Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'NEW H2H 20',
        description: 'HEAD TO HEAD',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 3600,
        entryFee: 2000,
        winningsPerPosition: {
          '3600': 1
        },
        selfReplicating: true,
        bonusPercentage: 2,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 400,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc4d',
        createdOn: '2021-11-04T07:06:53.304Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '6180fa03b2569b001f9dde16',
        tenant: 'dev',
        title: 'H2H5',
        description: 'head to head',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 900,
        entryFee: 500,
        winningsPerPosition: {
          '900': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: false,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  },
  {
    _id: '631301f38977f2001ed3422e',
    contests: [
      {
        _id: '63d294d767b0c2001d35fc3d',
        createdOn: '2023-01-24T06:47:47.294Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_5',
        description: 'Headtohead_5',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 300000,
        entryFee: 100000,
        winningsPerPosition: {
          '300000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc45',
        createdOn: '2023-01-24T06:29:14.978Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'headtohead',
        description: 'headtohead',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc35',
        createdOn: '2023-01-24T06:24:05.983Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'H2H',
        description: 'H2H',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 150000,
        entryFee: 100000,
        winningsPerPosition: {
          '150000': 1
        },
        selfReplicating: true,
        bonusPercentage: 0,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 100,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc37',
        createdOn: '2023-01-24T06:42:59.046Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtoheadtest_3',
        description: 'Headtoheadtest_3',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 100000,
        entryFee: 70000,
        winningsPerPosition: {
          '100000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      },
      {
        _id: '63d294d767b0c2001d35fc43',
        createdOn: '2023-01-24T06:44:09.220Z',
        deletedOn: null,
        contestTypeId: '6094d1232484deb6cdcce451',
        contestCategoryId: '631301f38977f2001ed3422e',
        tenant: 'dev',
        title: 'Headtohead_4',
        description: 'Headtohead_4',
        minimumPlayers: 2,
        maximumPlayers: 2,
        maxTeamPerUser: 1,
        winningsAmount: 200000,
        entryFee: 150000,
        winningsPerPosition: {
          '200000': 1
        },
        selfReplicating: true,
        bonusPercentage: 10,
        isConfirmed: false,
        isDynamicWinnings: false,
        adminFees: 200,
        requiredBucketNumber: 0,
        bucketSize: 0,
        minimumBasePayToEachWinner: 0,
        firstPositionPercentage: 15,
        percentageWinningsFromTotal: 50,
        matchDelayed: false,
        adminContest: true,
        isBallThrown: false,
        matchId: '63cbff1d96851a4d7f92725d',
        isCanceled: false,
        status: 1,
        statusText: 'Scheduled',
        gameState: 0,
        gameStateText: 'Default',
        calculatedPrizeMoney: 0,
        winningsLocked: false,
        filledTeamSlots: 0,
        states: {
          '1': true
        },
        verified: false
      }
    ]
  }
];
